import {
  ArithmeticOperationType,
  EventNotificationType,
  FormConstructorAutoFillColumnFieldValues,
  FormConstructorBlockType,
  FormConstructorFieldType,
  GridTypes,
  HazardCategory,
} from "./Enums";

import Constants from "./Common";

export interface ISelectOption {
  id: number | string;
  name: number | string;
}

export interface ISelectArithmeticOption extends ISelectOption {
  limit: number;
}

interface IExtendedSelectOption extends ISelectOption {
  key?: string;
}

export const EventNotificationTypeMapping: Array<ISelectOption> = [
  { id: EventNotificationType.Sms, name: "СМС" },
  { id: EventNotificationType.Email, name: "Email" },
  { id: EventNotificationType.SmsAndEmail, name: "CMC и Email" },
];

export const FormConstructorFieldTypeMapping: Array<ISelectOption> = [
  { id: FormConstructorFieldType.Text, name: "Поле строка" },
  { id: FormConstructorFieldType.FloatNumber, name: "Рациональное число" },
  { id: FormConstructorFieldType.Number, name: "Целое число" },
  { id: FormConstructorFieldType.Date, name: "Дата" },
  { id: FormConstructorFieldType.Time, name: "Время" },
  { id: FormConstructorFieldType.DateTime, name: "Дата и время" },
  { id: FormConstructorFieldType.Address, name: "Адрес" },
  {
    id: FormConstructorFieldType.LinkToUserDictionary,
    name: "Пользовательский справочник",
  },
  {
    id: FormConstructorFieldType.LinkToSystemDictionary,
    name: "Системный справочник",
  },
  { id: FormConstructorFieldType.File, name: "Файл" },
  { id: FormConstructorFieldType.Logic, name: "Логический" },
  { id: FormConstructorFieldType.Textarea, name: "Текстовое поле" },
  { id: FormConstructorFieldType.FileArray, name: "Список файлов" },
  { id: FormConstructorFieldType.LinkToForm, name: "Значение из другой формы" },
  { id: FormConstructorFieldType.LinkToOrganization, name: "Организация" },
  { id: FormConstructorFieldType.LinkToBuilding, name: "Здание" },
  { id: FormConstructorFieldType.Map, name: "Карта" },
  { id: FormConstructorFieldType.AutoFillColumn, name: "Поле-автозаполнение" },
  { id: FormConstructorFieldType.EnumSelect, name: "Список-множество" },
];

export const FormConstructorBlockSettingsWidthMapping: Array<ISelectOption> = [
  { id: 8, name: "33%" },
  { id: 16, name: "66%" },
  { id: 24, name: "100%" },
];

export const FormFieldNullableTypes = [
  FormConstructorFieldType.FloatNumber,
  FormConstructorFieldType.Number,
];

export const FormFieldTypeFromFormConstructorFieldType = {
  [FormConstructorFieldType.FloatNumber]: "decimal",
  [FormConstructorFieldType.Number]: "number",
  [FormConstructorFieldType.Textarea]: "textarea",
  [FormConstructorFieldType.Time]: "time",
  [FormConstructorFieldType.HiddenText]: "hidden",
};

export const FormConstructorBlockTypeMapping: Array<ISelectOption> = [
  { id: FormConstructorBlockType.Fields, name: "Список полей" },
  { id: FormConstructorBlockType.Table, name: "Табличные данные" },
];

export const FormConstructorAutoFillColumnFieldValuesMapping: Array<IExtendedSelectOption> =
  [
    {
      id: FormConstructorAutoFillColumnFieldValues.UserFullName,
      name: "Имя пользователя",
      key: "fullName",
    },
    {
      id: FormConstructorAutoFillColumnFieldValues.OrganizationName,
      name: "Название организации",
      key: "organizationName",
    },
    {
      id: FormConstructorAutoFillColumnFieldValues.ShortOrganizationName,
      name: "Короткое название организации",
    },
    {
      id: FormConstructorAutoFillColumnFieldValues.INN,
      name: "ИНН",
    },
    {
      id: FormConstructorAutoFillColumnFieldValues.ArithmeticField,
      name: "Арифметическая операция",
    },
  ];

export const ArithmeticOperationTypeMapping: Array<ISelectArithmeticOption> = [
  {
    id: ArithmeticOperationType.Fraction,
    name: "Доля",
    limit: 2,
  },
  {
    id: ArithmeticOperationType.Difference,
    name: "Разность",
    limit: 2,
  },
  {
    id: ArithmeticOperationType.Amount,
    name: "Сумма",
    limit: Infinity,
  },
  {
    id: ArithmeticOperationType.Percent,
    name: "Процент",
    limit: 2,
  },
];

export const HazardCategoryValuesMapping: Array<ISelectOption> = [
  {
    id: Constants.hazardCategoryNotSet,
    name: "Не присвоена",
  },
  {
    id: HazardCategory.Low,
    name: "Низкая",
  },
  {
    id: HazardCategory.Medium,
    name: "Средняя",
  },
  {
    id: HazardCategory.High,
    name: "Высокая",
  },
];

export const groupOfCategoryOptions: Array<ISelectOption> = [
  {
    id: 0,
    name: "Взрывопожароопасные",
  },
  {
    id: 1,
    name: "Жизнеобеспечения",
  },
  {
    id: 2,
    name: "Критически важные",
  },
  {
    id: 3,
    name: "Опасные производственные",
  },
  {
    id: 4,
    name: "Управление",
  },
];

export const ownershipTypeOptions: Array<ISelectOption> = [
  {
    id: 0,
    name: "Частная",
  },
  {
    id: 1,
    name: "Право собственности",
  },
  {
    id: 2,
    name: "Аренда",
  },
  {
    id: 3,
    name: "Безвозмездное использование",
  },
  {
    id: 4,
    name: "Государственная",
  },
  {
    id: 5,
    name: "Доверительное управление",
  },
  {
    id: 6,
    name: "Хозяйственное ведение",
  },
  {
    id: 7,
    name: "Право пользования объекта",
  },
  {
    id: 8,
    name: "Право не зарегистрировано",
  },
];

export const GridTypesValuesMapping: Array<ISelectOption> = [
  {
    id: GridTypes.HeatSupply,
    name: "Теплоснабжение",
  },
  {
    id: GridTypes.WaterSupply,
    name: "Водоснабжение",
  },
  {
    id: GridTypes.GasSupply,
    name: "Газоснабжение",
  },
  {
    id: GridTypes.OutdoorLightning,
    name: "Освещение",
  },
  {
    id: GridTypes.WaterDrainage,
    name: "Водоотведение",
  },
  {
    id: GridTypes.PowerSupply,
    name: "Электроснабжение",
  },
  {
    id: GridTypes.Ventilation,
    name: "Вентиляция",
  },
  {
    id: GridTypes.Canalization,
    name: "Канализирование",
  },
  {
    id: GridTypes.NegativeImpact,
    name: "Негативное воздействие",
  },
  {
    id: GridTypes.Coal,
    name: "Уголь",
  },
  {
    id: GridTypes.Masut,
    name: "Мазут",
  },
];

export const classfifierSectorTEKOptions: Array<ISelectOption> = [
  {
    id: 0,
    name: "Электроэнергетика",
  },
  {
    id: 1,
    name: "Добыча,транспортировка,переработка,хранение, газа и газоснабжение",
  },
  {
    id: 2,
    name: "Добыча нефти,ее транспортировка,переработка, и снабжение нефтепродуктами",
  },
  {
    id: 3,
    name: "Переработка угля,сланца и торфа, их хранение и снабжение",
  },
  {
    id: 4,
    name: "Теплоснабжение",
  },
];

export const pipeMetalConditionOptions: Array<ISelectOption> = [
  {
    id: 1,
    name: "50%",
  },
  {
    id: 2,
    name: "< 50%",
  },
  {
    id: 3,
    name: "Незначительная коррозия",
  },
  {
    id: 5,
    name: "Коррозия отсутствует",
  },
];

export const qualityOfWeldedJointsOptions: Array<ISelectOption> = [
  {
    id: 1,
    name: ">= 50",
  },
  {
    id: 2,
    name: "< 50",
  },
  {
    id: 3,
    name: "Годные",
  },
];

export const corrosionHazardOptions: Array<ISelectOption> = [
  {
    id: 1,
    name: "< 50%",
  },
  {
    id: 2,
    name: "> 50%",
  },
  {
    id: 3,
    name: "Незначительная коррозия",
  },
  {
    id: 4,
    name: "Коррозия отсутствует",
  },
];
